import useFadeIn from '../../hooks/useFadeIn';
import threeDogsLogo from '../../assets/3dogs-logo.png';
import './Contact.css';

const LinkedInIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const GitHubIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
  </svg>
);

const DownloadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 3v10m0 0l-3.5-3.5M10 13l3.5-3.5M4 16h12" />
  </svg>
);

const Contact = () => {
  const [ref, isVisible] = useFadeIn();

  return (
    <section className="contact section" id="contact">
      <div className={`container fade-in ${isVisible ? 'visible' : ''}`} ref={ref}>
        <p className="section-eyebrow">Connect</p>
        <h2 className="section-heading contact__heading">Let's Work Together</h2>
        <p className="contact__text">
          Open to conversations about fractional CTO engagements, advisory roles,
          or interesting technology challenges. Let's connect.
        </p>
        <div className="contact__links">
          <a
            href="https://www.linkedin.com/in/wbates/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact__btn"
          >
            <LinkedInIcon /> LinkedIn
          </a>
          <a
            href="https://github.com/wbates"
            target="_blank"
            rel="noopener noreferrer"
            className="contact__btn"
          >
            <GitHubIcon /> GitHub
          </a>
          <a
            href="https://3dogsadvisory.com"
            target="_blank"
            rel="noopener noreferrer"
            className="contact__btn"
          >
            <img src={threeDogsLogo} alt="" className="contact__btn-logo" /> 3 Dogs Advisory
          </a>
          <a href="/wbates_resume.docx" download className="contact__btn">
            <DownloadIcon /> Resume
          </a>
        </div>
        <a href="mailto:bill@3dogsadvisory.com" className="contact__email">
          bill@3dogsadvisory.com
        </a>
      </div>
    </section>
  );
};

export default Contact;
